import {
  ButtonGroup, Icon, IconButton,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import {
  BsCopy, BsFillTrashFill, BsArrowDown, BsArrowUp,
} from 'react-icons/bs';
import {
  cloneField, moveDown, moveUp, removeField,
} from './Editor/editorSlice';

/* eslint-disable jsx-a11y/click-events-have-key-events */
const FieldActions = ({ index }) => {
  const dispatch = useDispatch();

  const handleRemove = () => {
    dispatch(removeField(index));
  };

  const handleMoveUp = () => {
    dispatch(moveUp(index));
  };

  const handleMoveDown = () => {
    dispatch(moveDown(index));
  };

  const handleClone = () => {
    dispatch(cloneField(index));
  };

  return (
    <ButtonGroup isAttached size="xs" variant="ghost" border="1px solid" borderColor="gray.400">
      <IconButton colorScheme="gray" aria-label="Copy field" icon={<Icon as={BsCopy} onClick={handleClone} />} />
      <IconButton colorScheme="gray" aria-label="Remove field" icon={<Icon as={BsFillTrashFill} />} onClick={handleRemove} />
      <IconButton colorScheme="gray" aria-label="Move up" icon={<Icon as={BsArrowUp} />} onClick={handleMoveUp} />
      <IconButton colorScheme="gray" aria-label="Move down" icon={<Icon as={BsArrowDown} />} onClick={handleMoveDown} />
    </ButtonGroup>
  );
};

export default FieldActions;
